import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "pageTitle": "Visually Hidden API",
  "title": "Visually Hidden",
  "props": ["VisuallyHiddenProps"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DocsHeading = makeShortcode("DocsHeading");
const VisuallyHiddenProps = makeShortcode("VisuallyHiddenProps");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<DocsHeading type="api" mdxType="DocsHeading">Visually Hidden</DocsHeading>
<p>{`Using the `}<inlineCode parentName="p">{`VisuallyHidden`}</inlineCode>{` component will hide the children of this component visually, while still allowing the content to be accessed by screenreaders.`}</p>
<h2>{`Basic Usage`}</h2>
<pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import React from 'react';
import { VisuallyHidden } from 'react-magma-dom';

export function Example() {
  return (
    <VisuallyHidden>
      This text can be read by a screen reader, but does not appear on the
      screen.
    </VisuallyHidden>
  );
}
`}</code></pre>
<h2>{`Visually Hidden Props`}</h2>
<p><strong parentName="p">{`This component uses `}<inlineCode parentName="strong">{`forwardRef`}</inlineCode>{`. The ref is applied to the outer `}<inlineCode parentName="strong">{`div`}</inlineCode>{` element.`}</strong></p>
<p>{`All of the `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes"
      }}>{`global HTML attributes`}</a>{` can be provided as props and will be applied to the wrapping `}<inlineCode parentName="p">{`div`}</inlineCode>{` element that gets rendered.`}</p>
<VisuallyHiddenProps mdxType="VisuallyHiddenProps" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      